import { Route, Routes } from 'react-router-dom'

import {
  contractDetailsRoute,
  contractDetailsRoutes
} from 'features/ContractDetails/ContractDetailsRouter/routes'
import ContractDetailsGeneral from 'features/ContractDetails/ContractDetailsGeneral/ContractDetailsGeneral'
import Users from '../Users/Users'

const ContractDetailsRouter = () => (
  <Routes>
    {contractDetailsRoutes.map((route) => (
      <Route key={route.path} path={route.path} element={<route.component />} />
    ))}
    <Route path={contractDetailsRoute.users} element={<Users />}>
      <Route path={':subtab'} element={<Users />} />
    </Route>
    <Route index element={<ContractDetailsGeneral />} />
  </Routes>
)

export default ContractDetailsRouter
